export const AVAILABLE_LANGUAGES = ['en', 'fr', 'es', 'de', 'it', 'nl'];
export const DEFAULT_LANGUAGE = 'en';
export const AVAILABLE_COUNTRIES = ['ES', 'FR'];

// export const DB_PREFIX = 'dev_pms'
//
// export const DB_CONFIG = {
//   user: 'postgres',
//   password: '',
//   host: 'localhost',
//   database: DB_PREFIX + '_db',
//   max: 10, // max number of clients in the pool
//   idleTimeoutMillis: 30000, // how long a client is allowed to remain idle before being closed
//   availableLanguages: AVAILABLE_LANGUAGES,
//   defaultLanguage: DEFAULT_LANGUAGE,
// };

export const FILE_STORE = 'openstack'; // local

// export const HOST = 'http://localhost:8000';
export const HOST = '';
export const PMS_URL = '/';
export const ROOT_URL = '/api';
export const AUTH_URL = '/auth';
export const APP_URL = '/pms';
// export const API_ROOT_URL = HOST + ROOT_URL + APP_URL;
export const API_ROOT_URL = ROOT_URL + APP_URL;
export const FRONT_URL = '/front';
export const PUBLIC_URL = '/public';
export const FILESTORE_PATH = '/filestore';
// export const FILESTORE_URL = HOST + ROOT_URL + FILESTORE_PATH;
export const FILESTORE_URL = ROOT_URL + FILESTORE_PATH;
export const BACKEND_ADMIN_URL = '/admin';
export const FRONTEND_ADMIN_URL = '/admin';

export const DEBUG = true;



// WEBPACK FOOTER //
// ./src/config.js